import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M18.015,6.36125 C18.43125,6.7775 18.645,7.2925 18.65625,7.9075 L18.65625,16.3325 C18.645,16.9475 18.43125,17.46 18.015,17.87 C17.59875,18.28 17.08375,18.49625 16.46875,18.52 L3.34375,18.52 C2.72875,18.4975 2.2125,18.28125 1.7975,17.87 C1.38125,17.46 1.1675,16.9475 1.15625,16.3325 L1.15625,7.9075 C1.1675,7.2925 1.38125,6.7775 1.7975,6.36125 C2.21375,5.945 2.72875,5.73125 3.34375,5.72 L4.66,5.72 L9.1375,1.4475 C9.365,1.23125 9.62125,1.1225 9.90625,1.1225 C10.19125,1.1225 10.4475,1.23125 10.675,1.4475 L15.05,5.72 L16.46875,5.72 C17.08375,5.73125 17.59875,5.945 18.015,6.36125 L18.015,6.36125 Z M16.025,8.88125 C16.025,8.65375 15.93625,8.45375 15.76,8.2825 C15.58375,8.11125 15.38125,8.02 15.15375,8.00875 L4.66,8.00875 C4.4325,8.02 4.23,8.11125 4.05375,8.2825 C3.8775,8.45375 3.78875,8.6525 3.78875,8.88125 L3.78875,15.66625 C3.78875,15.89375 3.8775,16.09625 4.05375,16.2725 C4.23,16.44875 4.4325,16.5375 4.66,16.5375 L15.15375,16.5375 C15.38125,16.5375 15.58375,16.44875 15.76,16.2725 C15.93625,16.09625 16.025,15.89375 16.025,15.66625 L16.025,8.88125 L16.025,8.88125 Z M5.53125,14.795 L14.28125,14.795 L14.28125,9.77 L5.53125,9.77 L5.53125,14.795 Z M7.82125,5.8225 L11.99125,5.8225 L9.90625,3.8575 L7.82125,5.8225 L7.82125,5.8225 Z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </svg>
  )
}

const InfomationIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default InfomationIcon
